"use client";

import React from "react";

export default function Maps() {
  return (
    <section className="w-full">
      {/* Container com altura máxima de 600px */}
      <div className="w-full h-[600px] max-h-[600px] overflow-hidden">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3613.9796990269297!2d-50.1533471!3d-25.0686772!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94e8198868ece6d5%3A0xc8e872cce209b727!2sLG%20Centro%20Cont%C3%A1bil!5e0!3m2!1spt-BR!2sbr!4v1761073064189!5m2!1spt-BR!2sbr"
          className="w-full h-full border-0"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
}